import {FC, useEffect, useState} from 'react'
import {useParams} from "react-router-dom";
import {getAllPagesOperation} from "../wordpress/Operations";
import Sidebar from "../components/Sidebar";
import { bookingFlows, bookingDefault, settings } from '../constants/global'
import Footer from "../components/Footer";
import staticPageContent from "../lib/static-page-content";
import Modal from "../components/common/Modal/Modal";
import {getOrder} from "../wordpress/operations/get-order";
import Date from "../components/Date";
import Message from "../components/Hjulskifte/Message";

interface Props {
    className?: string
}

const HjulskifteUpdate: FC<Props> = ({ className }) => {
    const [content, setData] = useState(null);
    const [booking, setBooking] = useState(bookingDefault);
    const [order, setOrder] = useState<any>(null);

    useEffect(() => {
        if (!content) {
            getAllPagesOperation(setData)
        }
    }, [content]);

    // Äldre länkar har nyckeln i adressen, nya får den via react_data.
    let params = useParams();
    const order_key = params.order_key || window.react_data.time_update_key
    const user_id = params.user_id || window.react_data.user_id || undefined
    const slug = "andra-tid-hjulskifte"
    booking.order_key = order_key

    if(!content) // Wait for static content to load from Wordpress
        return

    if (!order) {
        getOrder(booking.order_key).then((val) => {
            console.log('order', val)
            val.booking.hjulskifte_update = {
                date : val.booking.date,
                time : val.booking.submission.time,
                user_id : user_id
            }

            if(val.status === 'idle') {
                val.booking.date = null
                val.booking.submission.time = null
            }

            val.booking.order_loading = false
            setBooking(val.booking)
            setOrder(val)
        })
        return;
    }

    let pageContent:ContentPage = staticPageContent(slug, content)

    bookingFlows['hjulskifte-arval'].step = bookingFlows['hjulskifte'].step = 'date'
    settings.auth = content.auth
    settings.vbo = content.vbo
    settings.rental = content.rental
    settings.debug = content.settings.debug
    settings.tire_shop = content.settings.tire_shop
    settings.react_thank_you = content.settings.react_thank_you
    settings.url = content.path

    if(process.env.NODE_ENV === 'development')
        booking.debug = false

    if(settings.debug) {
        booking.debug = true
    }else{
        console.log = function() {} // Prevent all console logs
    }

    if(className)
        booking.classNames.push(className);

    if(booking.classNames)
        className = booking.classNames.join(' ')

    let carBrand = booking.car.brand ? booking.car.brand.toLowerCase() : ''


    return (
        <div id={'h-container'} className={className}>
            <>
                <section id="wco-single-booking-page" className={'o-conten-wrap page-booking flow-' + booking.booking_flow + ' brand-'+carBrand}>
                    <div className="container">
                        {order.status === 'idle' || order.status === 'complete' || order.status === 'rebooked' ?
                            (
                                <>
                                    <Modal booking={booking} setBooking={setBooking}/>
                                    <div className="row">
                                        <div className="col-lg-9 col-md-8 col-sm-12 col-xs-12 col-xxs-12">
                                            <Date pageContent={pageContent} booking={booking} setBooking={setBooking} content={content}/>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-12 col-xs-12 col-xxs-12 booking-sidebar-container">
                                            <Sidebar booking={booking} workshops={content.workshops} setBooking={setBooking} content={content}/>
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <>
                                <div className="row">
                                    <div className="col-lg-3 col-xs-12">
                                    </div>
                                        <div className="col-lg-6 col-xs-12">
                                            <Message title={'Din bokning går ej att ändra.'}
                                                     content={'Ändring av din bokning är inte möjlig online mindre än 3 dagar före besöket.'}
                                                     contact={true}
                                            />
                                            <Sidebar booking={booking} workshops={content.workshops}
                                                     setBooking={setBooking} content={content}/>
                                        </div>
                                        <div
                                            className="col-lg-3 col-xs-12 booking-sidebar-container">

                                        </div>
                                    </div>
                                </>
                                )
                                }

                    </div>
                </section>
                <Footer booking={booking} setBooking={setBooking} content={content}/>
            </>
        </div>
    );
};

export default HjulskifteUpdate
